import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { AccessService } from "../../services/access/access.service";

export function tokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const accessService = inject(AccessService);

  const token = accessService.getToken();
  const skipLogout = req.headers.get('X-Skip-Logout');

  const authReq = token
    ? req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
      headers: req.headers.delete('X-Skip-Logout')
    })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        console.error('Token expired or invalid:', error.message);
        if (!skipLogout) {
          accessService.logout();
        }
      } else {
        console.error('Request Error:', error.message);
      }

      return throwError(() => error);
    })
  );
}
